module.exports = __webpack_public_path__ + "static/img/deviceDefaultImg.c94f6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/deviceDefaultImg.png
// module id = FCpB
// module chunks = 1